// app/storage-keys.ts — ключи localStorage таблицы. Значения по умолчанию равны прежним
// литералам signals app, чтобы сохранённые пользователями данные продолжали читаться.

import { PRESET_STORAGE_KEY } from "../domain";

export const RECENT_FILTERS_STORAGE_KEY = "smart-table-recent-filters";

export interface TableStorageKeys {
  presets: string;
  recentFilters: string;
}

export const DEFAULT_TABLE_STORAGE_KEYS: TableStorageKeys = {
  presets: PRESET_STORAGE_KEY,
  recentFilters: RECENT_FILTERS_STORAGE_KEY,
};
